import { render } from "./EditTransferPage.vue?vue&type=template&id=1de9e7ce&ts=true"
import script from "./EditTransferPage.vue?vue&type=script&lang=ts"
export * from "./EditTransferPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__